module.exports = __webpack_public_path__ + "static/media/photo_012.c8358088.JPG";